<template>
  <div>
    <el-row v-if="!tableData.hideHeaderBar" type="flex" align="bottom" justify="space-between" style="margin-bottom: 15px">
      <statistics :count-list="countList"/>
      <div>
        <span style="margin-right: 20px"><slot name="operateBar"></slot></span>
        <el-button style="font-size: 20px" class="info" type="text" icon="el-icon-setting" @click="showTableSet"></el-button>
        <el-button style="font-size: 20px" class="info" type="text" icon="el-icon-refresh" @click="$emit('refresh')"></el-button>
      </div>
    </el-row>
    <el-table :data="tableData.tableList" :row-key="getRowKeys" :expand-row-keys="expands" :size="size" :span-method="spanMethod"
              @selection-change="selectionChange" @expand-change="expandChange">
      <!--多选-->
      <el-table-column width="45" type="selection" v-if="tableData.isMultiple" align="center"></el-table-column>
      <!--序号-->
      <slot name="index"></slot>
      <!--列表项-->
      <template v-for="(item, index) in tableData.tableColumn">
        <el-table-column :key="index" :label="item.label" :width="item.width" :min-width="Math.max(item.minWidth || 0, flexWidth(item))"
                         :align="item.position || 'center'" :show-overflow-tooltip="item.tooltip || true">
          <template slot="header" v-if="item.tips">
            <el-tooltip effect="dark" placement="top-start">
              <el-button class="tips" icon="el-icon-info">{{item.label}}</el-button>
              <template slot="content">
                <div v-html="item.tips" class="content"></div>
              </template>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <slot :name="item.property" :row="scope.row" :col="scope.column">
              <span v-html="showTableData(item.property, scope.row, item.format)"></span>
            </slot>
          </template>
        </el-table-column>
      </template>
      <!--展开项-->
      <el-table-column type="expand" v-if="tableData.hasExpand" label="更多" width="55">
        <template slot-scope="scope">
          <el-form label-position="left" class="table-expand" :label-width="tableData.expandLabelWidth + 'px'">
            <el-row :gutter="20">
              <template v-for="(item, index) in tableData.expandColumn">
                <el-col :span="12" :key="index">
                  <el-form-item :label="item.label" >
                    <span v-if="item.formatFun" :title="item.formatFun(scope.row)">{{item.formatFun(scope.row)}}</span>
                    <span v-else v-html="showTableData(item.property, scope.row, item.format)" :title="showTableData(item.property, scope.row, removeColor(item.format))"></span>
                  </el-form-item>
                </el-col>
              </template>
            </el-row>
          </el-form>
        </template>
      </el-table-column>
      <!--      操作栏-->
      <slot name="actionBar"></slot>
    </el-table>
    <table-column-set v-if="tableColumnSet.visible" :dialog-data="tableColumnSet" @finish="getTableColumn"/>
  </div>
</template>

<script>
import Statistics from "@view/components/Statistics"
import TableColumnSet from "./dialog/TableColumnSet"
export default {
  name: "vueTable",
  components: {Statistics,TableColumnSet},
  props: {
    size: {
      type: String,
      default: "",
    },
    countList: {
      type: Array,
      default: () => []
    },
    tableData: Object,
    selectList: Array,
    spanMethod: Function,
  },
  data() {
    return {
      expands: [],
      maxColumn: 12,
      tableColumnSet: {title: "自定义列表字段", visible: false, columnList: [], checkedList: [], api: this.$route.path},
      columnList: JSON.parse(JSON.stringify(this.tableData.tableColumn))
    }
  },
  created() {
    this.getTableColumn();
  },
  methods: {
    flexWidth(row) {
      const label = row.label;
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      context.font = "14px Microsoft YaHei";
      const width = context.measureText(label).width;
      const sortWidth = row.sort ? 40 : 20;
      return +width.toFixed(0) + sortWidth;
    },
    showTableSet() {
      this.tableColumnSet.visible = true;
      this.tableColumnSet.columnList = this.columnList;
      this.tableColumnSet.maxColumn = this.maxColumn;
      this.tableColumnSet.checkedList = this.tableData.tableColumn.map(item => item.property);
    },
    getTableColumn() {
      let columnList = localStorage.getItem(this.$route.path);
      columnList && (columnList = JSON.parse(columnList));
      if (Array.isArray(columnList) && columnList.length) {
        this.tableData.tableColumn = this.columnList.filter(item => columnList.includes(item.property));
      } else {
        this.tableData.tableColumn = this.columnList.slice(0, this.maxColumn);
      }
    },
    removeColor(list) {
      return list?.map(item => ({id:item.id, msg:item.msg}));
    },
    getRowKeys(row) {
      return row.id;
    },
    selectionChange(list) {
      this.$emit("update:selectList", list);
    },
    expandChange(row, expandedRows) {
      this.expands = [];
      if (expandedRows.length) {
        this.expands.push(row.id);
      }
    }
  }
}
</script>

<style scoped lang="scss">
.content {
  line-height: 20px;
}
</style>
